import { render, staticRenderFns } from "./SelectFeaturingArtist.vue?vue&type=template&id=a2c349f0&"
import script from "./SelectFeaturingArtist.vue?vue&type=script&lang=js&"
export * from "./SelectFeaturingArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports